import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import React from "react";
import ReactDOM from "react-dom";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.min.css";
import "react-notifications/lib/notifications.css";
import "./i18n";
import "./index.css";
import App from "App";

ReactDOM.render(
  <React.Fragment>
    <App />
  </React.Fragment>,
  document.getElementById("root")
);
